module.exports = __webpack_public_path__ + "img/CRT_P2_Sword-001.409172d5.png";